import { AddressElement, PaymentElement } from '@stripe/react-stripe-js';

/**
 *
 *
 * Must be a child of a <StripeElements> component
 * Read more: https://stripe.com/docs/stripe-js/react#available-element-components
 *
 */

const StripePaymentElement = ({ defaultValues = {}, onChange, handleBlur, handleFocus }) => {
  const billingAddressOptions = {
    allowedCountries: ['US'],
    mode: 'billing',
  };

  const paymentOptions = {
    defaultValues: {
      billingDetails: { email: defaultValues.email },
    },
    fields: {
      billingDetails: {
        address: 'never',
      },
    },
  };

  return (
    <>
      <AddressElement options={billingAddressOptions} className="mb-4" />
      <PaymentElement
        options={process.env.CYPRESS ? {} : paymentOptions}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </>
  );
};

StripePaymentElement.propTypes = {
  defaultValues: PropTypes.object,
  onChange: PropTypes.func,
  handleFocus: PropTypes.func,
  handleBlur: PropTypes.func,
};

export default StripePaymentElement;
